import Column from '@components/Column';
import CardSide from '@components/membership/CardSide';
import Row from '@components/Row';
import ScrollBar from '@components/ScrollBar';
import Text from '@components/Text';
import colors from '@constants/colors';
import { PointCardRow } from '@models/point';
import { useRef, useState } from 'react';

import usePointHistory from './hooks/usePointHistory';
import PointLogRow from './PointLogRow';
import styles from './styles.module.scss';

interface Props {
    pointCard: PointCardRow;
}

function PointLog({ pointCard }:Props) {
  const { shopName, balance, shopId } = pointCard;
  const [expand, setExpand] = useState<boolean>(false);
  const { pointHistories, fetchNext } = usePointHistory(shopId);
  const ref = useRef<HTMLDivElement>(null);
  return (
      <div className={styles.container}>
          <Row className={styles.top}>
              <div className={`${styles.bar} ${expand ? styles.expand : ''}`} />
              <CardSide className={styles.side} color={expand ? colors.gray6 : colors.gray4}/>

              <Text className={styles.shopName}
                    fontWeight='bold'
                    color={colors.gray9} >
                  {shopName}
              </Text>
          </Row>

          <div className={`${styles.base} ${expand ? styles.expand : ''}`} >
              <div className={`${styles.contents} ${(!expand) ? styles.hide : ''}`}>
                  <div className={styles.divider}/>
                  <div className={styles.logsContainer}>
                      <Column fullWidth spacing={18}
                              className={styles.logs}
                              onScroll={(e) => {
                                const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;
                                const percent = scrollTop / (scrollHeight - offsetHeight);
                                if (percent >= 0.9) {
                                  fetchNext();
                                }
                              }}
                              ref={ref} >
                          {pointHistories.map((pointHistory, i) => (
                              <PointLogRow pointHistory={pointHistory} key={i.toString()} />
                          ))}
                      </Column>
                      <ScrollBar containerRef={ref}
                                 containerHeight={386}/>
                  </div>
              </div>
          </div>
             <div className={`${styles.overlay} ${expand ? styles.expand : ''}`} />
          <div className={styles.text} onClick={() => setExpand(!expand)}>
              <Text size='lg' fontWeight='bold' color={expand ? colors.white : colors.gray7}>
                  {balance.toLocaleString()}점
              </Text>
          </div>
      </div>
  );
}

export default PointLog;
